<a [fcContentLink]="content" [analyticsMode]="analyticsMode"></a>